(() => {
  document.querySelectorAll('.venue-content').forEach((section) => {
    const updateContent = () => {
      const currentVenue = get_venue();
      const sectionVenues = section.dataset.venues?.split(',');

      if(sectionVenues.includes(currentVenue)){
        section.classList.remove('hidden');
      }else{
        section.classList.add('hidden');
      }
    }

    updateContent();
    document.body.addEventListener('venueChanged', updateContent);
  });
})();